import { useEffect, useLayoutEffect, useState } from "react";
import { BUTTON_STYLE, INPUT_STYLE } from "../../assets/constants";
import { useNavigate } from "react-router-dom";

export default function NewAnnounement() {
  const [announcement, setAnnouncement] = useState(null);

  const handlePublish = () => {
    localStorage.setItem("announcement", announcement);
  };
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  useLayoutEffect(() => {
    if (user.role !== "ADMIN") {
      localStorage.removeItem("user");
      navigate("/login");
      return;
    }
  }, []);
  return (
    <>
      <h1
        tabIndex="0"
        className="uppercase focus:outline-none text-base sm:text-lg md:text-xl lg:text-2xl font-bold leading-normal text-gray-800"
      >
        Create Announement
      </h1>
      <div className="space-y-4 mt-4">
        <textarea
          rows={"10"}
          className={`${INPUT_STYLE}`}
          onChange={(e) => setAnnouncement(e.target.value)}
        />
        <button
          className={`${BUTTON_STYLE} px-5 font-medium py-3`}
          onClick={handlePublish}
        >
          Publish Announcement
        </button>
      </div>
    </>
  );
}
